Controller = App.loadClass 'core::Angular/Controller'

class exports.PracticesController extends Controller
    constructor: (@scope, @transitions, @modal, @http, @service, @state) ->
        super

        @scope.$watch 'service.fpcResult.data.economic_value_for_grain', (value, oldValue) =>
            if value > 100
                @service.fpcResult.data.economic_value_for_grain = 100
            else if value < 0
                @service.fpcResult.data.economic_value_for_grain = 0

            # Default crop residue removed to yes if economic_value_for_grain is less than 100
            if value < 100 and value isnt oldValue and oldValue isnt undefined
                @service.fpcResult.data.crop_residue_removed = true

        @scope.$watch 'service.fpcResult.data.water_applied', (value, oldValue) =>
            if value < 0
                @service.fpcResult.data.water_applied = oldValue

        @scope.$watch 'service.fpcResult.data.previous_crop_residue_removed', (value, oldValue) =>
            if (oldValue is undefined or oldValue is false) and value is true
                # dont overwrite the existing value if there is one
                # https://www.pivotaltracker.com/story/show/166441283
                if not @service.fpcResult.data.selected_previous_crop
                    @service.fpcResult.data.selected_previous_crop = @service.previousCrop?.crop
                # dont overwrite the existing value if there is one
                # https://www.pivotaltracker.com/story/show/166441283
                if @service.previousCrop? and not @service.fpcResult.data.previous_crop_yield
                    @service.fpcResult.data.previous_crop_yield = @service.previousFieldprintCropYield.estimated_yield
            else if oldValue is true and value is false
                @service.fpcResult.data.selected_previous_crop = null
                @service.fpcResult.data.previous_crop_yield = null

        for property in [
            'dryland_projected'
            'dryland_actual'
            'irrigated_projected'
            'irrigated_actual'
        ]
            fn = (prop) =>
                @scope.$watch "service.fpcResult.data.#{prop}", (value, oldValue) =>
                    if value > 10000
                        @service.fpcResult.data[prop] = oldValue

            fn(property)

        @service.onDataLoaded @scope, () =>
            if (not @service.fpcResult.data.manual_irrigated? or not @service.fpcResult.data.manual_irrigated) and @irrigationMapHasCrop() and @irrigationMapHasDetails()
                @service.fpcResult.data.irrigated = true

            if not @irrigationMapHasCrop() or not @irrigationMapHasDetails()
                @service.fpcResult.data.irrigated = false

            if not @service.fpcResult.data.manual_irrigated_projected? and @irrigationMapExists()
                @service.fpcResult.data.irrigated_projected = @calculateDefaultIrrigatedProjected()

            if not @service.fpcResult.data.manual_dryland_projected? and @irrigationMapExists()
                @service.fpcResult.data.dryland_projected = @calculateDefaultDrylandProjected()

            # Set the actual yield values based on the irrigation map crossed with the yield map
            @service.fpcResult.data.dryland_actual = parseInt(@service.fpcResult.irrigation_map?.average_yield?.dryland + 0.5)
            @service.fpcResult.data.irrigated_actual = parseInt(@service.fpcResult.irrigation_map?.average_yield?.irrigated + 0.5)

            # If the field is not irrigated, then set dryland_actual to the fieldwide average
            if not @service.fpcResult.data.dryland_actual
                @service.fpcResult.data.dryland_actual = parseInt(@service.fpcResult.average_yield + 0.5)

            # Prevent 0 from showing up, make it null instead
            if not @service.fpcResult.data.dryland_actual
                @service.fpcResult.data.dryland_actual = null

            # Prevent "Actual" from being selected if there is no yield map
            if not @service.fpcResult.data.dryland_actual and not @service.fpcResult.data.dryland_actual
                @service.fpcResult.data.yield_to_use = 'projected'

        @service.onSaveTriggers.push () =>
            # Needed because mf-guard-min/max can be bypassed by directly clicking on the save button
            resetIfBeyondLimits = (prop, min, max) =>
                if _.get(@service, prop) and (_.get(@service, prop) < min or _.get(@service, prop) > max)
                    _.set(@service, prop, null)

            resetIfBeyondLimits('fpcResult.data.water_applied', @service.irrigationValidationValues().min, @service.irrigationValidationValues().max)
            resetIfBeyondLimits('fpcResult.data.deep_aquifer_ground_water_applied', @service.irrigationValidationValues().min, @service.irrigationValidationValues().max)
            resetIfBeyondLimits('fpcResult.data.irrigated_projected', @service.validationCropValues[@service.crop].min, @service.validationCropValues[@service.crop].max)
            resetIfBeyondLimits('fpcResult.data.dryland_projected', @service.validationCropValues[@service.crop].min, @service.validationCropValues[@service.crop].max)

    irrigationMapExists: () =>
        return @service.fpcResult.irrigation_map?

    irrigationMapHasCrop: () =>
        return @irrigationMapExists() and @service.mfCrop in @service.fpcResult.irrigation_map?.extra_info?.crops

    irrigationMapHasDetails: () =>
        return @service.fpcResult.irrigation_map?.details?

    openPestMgmtDialog: () =>
        @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/grower/fieldprint/pest-mgmt-dialog'
            controller: 'DialogController'

    openCropResidueRemovedDialog: () =>
        @modal.open
            windowClass: 'modal-width'
            templateUrl: 'views/grower/fieldprint/crop-residue-dialog'
            controller: 'Fieldprint.Controllers.CropResidueRemovedController'

    openLimeDialog: () =>
        @modal.open
            windowClass: 'modal-width'
            templateUrl: 'views/grower/fieldprint/applied-lime-dialog'
            controller: 'Fieldprint.Controllers.LimeController'

    irrigatedChanged: () =>
        if @service.fpcResult.data.irrigated and (not @irrigationMapExists() or not @irrigationMapHasCrop() or not @irrigationMapHasDetails())
            if not @irrigationMapExists()
                title = 'Add Irrigation Map'
                message = "You have indicated that #{@service.fpcResult.field_name} is irrigated, but we have no Irrigation<br>map on record. Would you like to create one now?"
                state = 'grower.fieldprint-define'
            else if not @irrigationMapHasCrop()
                title = 'Edit Irrigation Map'
                message = "You have indicated that #{@service.fpcResult.field_name} is irrigated, but the Irrigation<br>map on record does not have data for #{@service.mfCrop}. Would you like to edit it now?"
                state = 'grower.fieldprint-add-crop-irrigation'
            else if not @irrigationMapHasDetails()
                title = 'Add Irrigation Details'
                message = "You have indicated that #{@service.fpcResult.field_name} is irrigated, but the Irrigation<br>map on record does not include Irrigation Details. Would you like to add them now?"
                state = 'grower.fieldprint-add-crop-irrigation'

            newscope = @scope.$new()
            newscope.title = title
            newscope.body = message

            dlg = @modal.open
                templateUrl: 'backend/core/confirm-dialog'
                controller: 'ConfirmDialogController'
                scope: newscope

            dlg.result.then () =>
                @service.fpcResult.data.manual_irrigated = false
                @service.fpcResult.data.irrigated = false
                @service.save @service.fpcResult.id
                .then () =>
                    @state.go state,
                        request: JSON.stringify({
                            year: @service.year
                            field_id: @service.field
                            crop: @service.mfCrop
                            layer_id: @service.fpcResult.irrigation_map?.id
                            layers_title: @service.fpcResult.irrigation_map?.name
                            redirectId: @state.params.id
                            redirectState: 'fieldprint'
                            step: @state.params.step
                        })
            , () =>
                @service.fpcResult.data.irrigated = false
        else
            @service.fpcResult.data.manual_irrigated = true

    calculateDefaultIrrigatedProjected: () =>
        if not @service.fpcResult.irrigation_map?.extra_info.mappings[@service.mfCrop]
            return ''
        range = @service.fpcResult.irrigation_map?.extra_info.mappings[@service.mfCrop].irrigated_range
        if not range
            return ''
        return Math.round((range.min + range.max) / 2)

    calculateDefaultDrylandProjected: () =>
        if not @service.fpcResult.irrigation_map?.extra_info.mappings[@service.mfCrop]
            return ''
        range = @service.fpcResult.irrigation_map?.extra_info.mappings[@service.mfCrop].dryland_range
        if not range
            return ''
        return Math.round((range.min + range.max) / 2)

    irrigatedProjectedChanged: () =>
        if @service.fpcResult.data.irrigated_projected is 0
            @service.fpcResult.data.irrigated_projected = @calculateDefaultIrrigatedProjected()
            @service.fpcResult.data.manual_irrigated_projected = false
        else
            @service.fpcResult.data.manual_irrigated_projected = true

    irrigatedDrylandChanged: () =>
        if @service.fpcResult.data.dryland_projected is 0
            @service.fpcResult.data.dryland_projected = @calculateDefaultDrylandProjected()
            @service.fpcResult.data.manual_dryland_projected = false
        else
            @service.fpcResult.data.manual_dryland_projected = true
